import { API_URL } from '../../../app-config/constants';
import { Review } from '../../react/features/Reviews/types';
import { post } from '../request';

export type ReviewImportResponse = {
    reviews: Review[];
    errors: string[];
};

importReviewsFromCsv.operation = 'NO_OPERATION';
export function importReviewsFromCsv(cycleId: string, data: string) {
    return post<ReviewImportResponse>(`${API_URL}/review-cycle/${encodeURIComponent(cycleId)}/reviews/import-csv`, {
        postData: { data },
    });
}
